__turbopack_context__.v({
  "breadcrumbGroup": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbGroup",
  "breadcrumbs": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbs",
  "breadcrumbsList": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbsList",
  "breadcrumbsListItem": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbsListItem",
  "breadcrumbsListItemLink": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbsListItemLink",
  "breadcrumbsSeparator": "resource-breadcrumbs-module-scss-module__2v3vxq__breadcrumbsSeparator",
});
